export const requestConfig = {
  url: process.env.BASE_API || 'https://3tzy7vejk6yvxubav7ziki7yxe0dlfnj.lambda-url.us-west-2.on.aws/api/v1',
  // url: '/proxy',
  timeout: 30000
}



// WEBPACK FOOTER //
// ./src/api/index.js